<template>
  <div class="login-page">
    <!-- 视频背景（增加容错） -->
    <div class="video-background">
      <video autoplay loop muted playsinline>
        <source src="../assets/111.mp4" type="video/mp4">
        <!-- 视频加载失败的备用背景 -->
        Your browser does not support the video tag.
      </video>
      <!-- 黑暗遮罩，提升文字可读性 -->
      <div class="video-overlay"></div>
    </div>

    <!-- 左侧品牌区（垂直居中） -->
    <div class="left-content">
      <div class="brand-wrapper">
        <img src="../assets/logo.png" alt="SDIBAN Logo" class="logo">
        <h1>承德市吴横科技有限公司分销后台</h1>
        <p class="english-slogan">Forge a Self-Reliant Empire for Traffic Advertising Monetization</p>
        <p class="chinese-slogan">打造独立自主的流量广告变现王国</p>
      </div>
      <!-- 优雅的装饰三角形（不干扰内容） -->
      <div class="decorative-triangle"></div>
    </div>

    <!-- 右侧登录卡片（垂直居中） -->
    <div class="login-container">
      <el-card class="login-card" shadow="hover">
        <div class="login-header">
          <h2>登录</h2>
        </div>
        <el-form ref="loginForm" :model="loginForm" :rules="loginRules" label-width="0px">
          <el-form-item prop="username">
            <el-input
                v-model="loginForm.username"
                placeholder="请输入账号"
                prefix-icon="el-icon-user"
                @keyup.enter.native="handleLogin"
            />
          </el-form-item>
          <el-form-item prop="password">
            <el-input
                v-model="loginForm.password"
                type="password"
                placeholder="请输入密码"
                prefix-icon="el-icon-lock"
                @keyup.enter.native="handleLogin"
            />
          </el-form-item>
          <el-form-item>
            <el-checkbox v-model="rememberMe">记住账号</el-checkbox>
          </el-form-item>
          <el-form-item>
            <el-button
                type="primary"
                style="width: 100%"
                @click="handleLogin"
                :loading="loading"
            >
              登录
            </el-button>
          </el-form-item>
        </el-form>
        <div class="footer-links">
          <a href="#" @click.prevent="showContactAdmin">帮助</a>
          <a href="#" @click.prevent="showForgotPassword">忘记密码</a>
        </div>
      </el-card>
    </div>
  </div>
</template>

<script>
import { post } from '@/utils/http.js'

export default {
  name: 'LoginPage',
  data() {
    return {
      loginForm: {
        username: '',
        password: ''
      },
      loginRules: {
        username: [
          { required: true, message: '请输入用户名', trigger: 'blur' }
        ],
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' }
        ]
      },
      loading: false,
      rememberMe: false
    }
  },
  methods: {
    async handleLogin() {
      this.$refs.loginForm.validate(async valid => {
        if (valid) {
          this.loading = true;
          try {
            const response = await post('/admin/AdminAccount/login', {
              username: this.loginForm.username,
              password: this.loginForm.password
            });

            if(response.code === 200 && response.data) {
              localStorage.setItem('token', response.data.token);
              localStorage.setItem('role', response.data.role);
              localStorage.setItem('username', this.loginForm.username);

              if (this.rememberMe) {
                localStorage.setItem('rememberedUsername', this.loginForm.username);
              } else {
                localStorage.removeItem('rememberedUsername');
              }

              this.$router.push('/ad-revenue');
              this.$message.success('登录成功');
            } else {
              this.$message.error(response.msg || '登录失败：未返回有效数据');
            }
          } catch (error) {
            this.$message.error(error.message || '登录失败');
          } finally {
            this.loading = false;
          }
        }
      });
    },
    showForgotPassword() {
      this.$message.info('请联系系统管理员重置密码');
    },
    showContactAdmin() {
      this.$message.info('请联系系统管理员获取帮助');
    }
  },
  mounted() {
    const rememberedUsername = localStorage.getItem('rememberedUsername');
    if (rememberedUsername) {
      this.loginForm.username = rememberedUsername;
      this.rememberMe = true;
    }
  }
}
</script>

<style scoped>
/* 基础布局：左右两侧水平居中 + 垂直居中 */
.login-page {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  padding: 20px;
  position: relative;
  overflow-x: hidden;
}

/* ----- 视频背景 (增强稳定性和视觉效果) ----- */
.video-background {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
  z-index: -2;
}

.video-background video {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

/* 半透明遮罩，提升左侧文字可读性 */
.video-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.15);
  backdrop-filter: brightness(1);
}

/* ----- 左侧品牌区 (垂直居中，文字清晰) ----- */
.left-content {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  color: white;
  padding: 40px 20px;
  position: relative;
  z-index: 1;
  min-height: 60vh;
}

.brand-wrapper {
  max-width: 600px;
  animation: fadeInUp 0.8s ease-out;
  transform: translateX(55%);
}

.logo {
  width: 100px;
  margin-bottom: 20px;
  filter: drop-shadow(0 4px 8px rgba(0,0,0,0.2));
}

.left-content h1 {
  font-size: 2.2rem;
  font-weight: 600;
  margin-bottom: 16px;
  text-shadow: 0 2px 12px rgba(0,0,0,0.3);
  letter-spacing: 1px;
}

.english-slogan {
  font-size: 0.9rem;
  opacity: 0.85;
  margin-bottom: 8px;
  letter-spacing: 1px;
}

.chinese-slogan {
  font-size: 1rem;
  opacity: 0.9;
  font-weight: 500;
  background: rgba(0,0,0,0.3);
  display: inline-block;
  padding: 4px 16px;
  border-radius: 30px;
  backdrop-filter: blur(4px);
}

/* 装饰性三角形（纯视觉，不干扰交互） */
.decorative-triangle {
  position: absolute;
  bottom: 20px;
  left: 20px;
  width: 0;
  height: 0;
  border-left: 80px solid transparent;
  border-right: 80px solid transparent;
  border-bottom: 120px solid rgba(255,215,0,0.15);
  pointer-events: none;
  z-index: 0;
}

/* ----- 右侧登录卡片 (垂直居中，半透明毛玻璃) ----- */
.login-container {
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 20px;
  max-width: 500px;
}

.login-card {
  width: 100%;
  border-radius: 24px;
  background: rgba(255, 255, 255, 0.92);
  backdrop-filter: blur(12px);
  border: 1px solid rgba(255, 255, 255, 0.3);
  box-shadow: 0 20px 35px rgba(0, 0, 0, 0.2);
  transition: transform 0.3s ease;
}

.login-card:hover {
  transform: translateY(-5px);
}

.login-header {
  text-align: center;
  font-size: 24px;
  font-weight: 600;
  color: #2c3e50;
  padding: 20px 0 10px;
  margin-bottom: 10px;
  position: relative;
}

.login-header h2 {
  margin: 0;
  font-weight: 600;
}

.el-form {
  padding: 0 24px 10px;
}

/* 表单输入框样式微调 */
.el-input__inner {
  border-radius: 40px;
  height: 44px;
  line-height: 44px;
}

.el-button--primary {
  border-radius: 40px;
  height: 44px;
  font-size: 16px;
  font-weight: 500;
  background: linear-gradient(135deg, #409EFF, #36d6ff);
  border: none;
  box-shadow: 0 4px 12px rgba(64,158,255,0.3);
}

.el-button--primary:hover {
  opacity: 0.9;
  transform: scale(0.98);
}

.footer-links {
  display: flex;
  justify-content: space-between;
  padding: 0 24px 24px;
}

.footer-links a {
  color: #606266;
  font-size: 13px;
  text-decoration: none;
  transition: color 0.2s;
}

.footer-links a:hover {
  color: #409EFF;
}

/* 动画 */
@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* ----- 响应式适配（手机/平板） ----- */
@media screen and (max-width: 768px) {
  .login-page {
    flex-direction: column;
    justify-content: center;
  }

  .left-content {
    flex: none;
    width: 100%;
    min-height: auto;
    padding: 30px 20px 20px;
  }

  .left-content h1 {
    font-size: 1.6rem;
  }

  .login-container {
    flex: none;
    width: 100%;
    max-width: 400px;
    margin-bottom: 40px;
  }

  .decorative-triangle {
    border-left: 50px solid transparent;
    border-right: 50px solid transparent;
    border-bottom: 80px solid rgba(255,215,0,0.1);
  }
}

@media screen and (max-width: 480px) {
  .left-content h1 {
    font-size: 1.3rem;
  }
  .english-slogan, .chinese-slogan {
    font-size: 0.75rem;
  }
  .login-card {
    margin: 0 10px;
  }
}
</style>